/* ==========================================================================
   TapStar — global.js
   Vanilla JS: no framework, no build step.
   ========================================================================== */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {};
  var strings = (window.theme && window.theme.strings) || {};
  var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Money formatting (Shopify-compatible) ---------- */
  function formatMoney(cents, format) {
    var fmt = format || moneyFormat;
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function defaultTo(v, d) { return (v === undefined || v === null) ? d : v; }
    function thousands(number, precision, thousandsSep, decimalSep) {
      precision = defaultTo(precision, 2);
      thousandsSep = defaultTo(thousandsSep, ',');
      decimalSep = defaultTo(decimalSep, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousandsSep);
      var cts = parts[1] ? decimalSep + parts[1] : '';
      return dollars + cts;
    }

    switch (fmt.match(placeholderRegex)[1]) {
      case 'amount': value = thousands(cents, 2); break;
      case 'amount_no_decimals': value = thousands(cents, 0); break;
      case 'amount_with_comma_separator': value = thousands(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = thousands(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = thousands(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = thousands(cents, 0, ' ', ''); break;
      default: value = thousands(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }
  window.theme.formatMoney = formatMoney;

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    if (!document.body.classList.contains('anim-on')) return;
    var items = $$('[data-reveal]');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Generic drawer/overlay ---------- */
  var overlay;
  function ensureOverlay() {
    if (overlay) return overlay;
    overlay = $('[data-overlay]');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'overlay';
      overlay.setAttribute('data-overlay', '');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.appendChild(overlay);
    }
    overlay.addEventListener('click', closeAll);
    return overlay;
  }
  function openPanel(el) {
    if (!el) return;
    ensureOverlay().setAttribute('aria-hidden', 'false');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeAll() {
    $$('[data-panel]').forEach(function (p) { p.setAttribute('aria-hidden', 'true'); });
    if (overlay) overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- Mobile navigation ---------- */
  function initMobileNav() {
    var burger = $('[data-burger]');
    var nav = $('[data-mobile-nav]');
    if (burger && nav) {
      burger.addEventListener('click', function () { openPanel(nav); });
    }
    $$('[data-close-panel]').forEach(function (btn) {
      btn.addEventListener('click', closeAll);
    });
  }

  /* ---------- Cart ---------- */
  function getCart() {
    return fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
  }

  function shipBarHtml(totalCents) {
    var fs = window.theme.freeShipping || {};
    if (!fs.enabled || !fs.threshold || totalCents <= 0) return '';
    var remaining = fs.threshold - totalCents;
    var pct = Math.min(100, Math.round((totalCents / fs.threshold) * 100));
    var msg = remaining > 0
      ? 'Noch <strong>' + formatMoney(remaining) + '</strong> bis zum kostenlosen Versand'
      : '🎉 Du hast <strong>kostenlosen Versand</strong> freigeschaltet!';
    return '<div class="ship-bar"><div class="ship-bar__msg">' + msg + '</div>' +
      '<div class="ship-bar__track"><div class="ship-bar__fill" style="width:' + pct + '%"></div></div></div>';
  }

  /* Reseller-Bundles kommen blanko – fuer sie brauchen wir keine Unternehmensdaten. */
  var BLANK_TYPE = 'Reseller-Bundle';
  var DIGITAL_TYPE = 'Digitales Produkt';
  function needsCoding(cart) {
    return (cart.items || []).some(function (item) {
      return item.product_type !== BLANK_TYPE && item.product_type !== DIGITAL_TYPE;
    });
  }
  function hasType(cart, type) {
    return (cart.items || []).some(function (item) { return item.product_type === type; });
  }
  /* Nur versandpflichtige Artikel zaehlen fuer den Gratis-Versand-Balken. */
  function shippableTotal(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      return sum + (item.requires_shipping ? item.final_line_price : 0);
    }, 0);
  }
  /* Upsell: Playbook, nur wenn ein Reseller-Bundle drin liegt und das Playbook noch fehlt. */
  function upsellHtml(cart) {
    var u = window.theme.upsell;
    if (!u || !hasType(cart, BLANK_TYPE) || hasType(cart, DIGITAL_TYPE)) return '';
    return '<div class="upsell" data-upsell>' +
      (u.image ? '<a class="upsell__img" href="' + u.url + '"><img src="' + u.image + '" alt="" width="72" height="72" loading="lazy"></a>' : '') +
      '<div class="upsell__body"><span class="upsell__tag">Passend zu deinem Bundle</span>' +
      '<a class="upsell__title" href="' + u.url + '">' + u.title + '</a>' +
      '<p>Einrichtung, die richtigen Betriebe, Gesprächsleitfaden und Marge – als PDF, sofort per Download.</p></div>' +
      '<div class="upsell__buy"><span class="upsell__price">' + formatMoney(u.price) + '</span>' +
      '<button type="button" class="btn btn--secondary" data-upsell-add data-variant-id="' + u.variant_id + '">Hinzufügen</button></div></div>';
  }

  function renderDrawer(cart) {
    var body = $('[data-cart-body]');
    var foot = $('[data-cart-foot]');
    if (!body || !foot) return;

    if (!cart.item_count) {
      body.innerHTML = '<div class="cart-empty"><p>Dein Warenkorb ist leer.</p>' +
        '<a class="btn" href="' + routes.cart_url.replace('/cart', '/collections/all') + '">Produkte ansehen</a></div>';
      foot.innerHTML = '';
      return;
    }

    var lines = cart.items.map(function (item, index) {
      var img = item.image ? item.image.replace(/(\.[^.]*)$/, '_140x140$1') : '';
      var variant = item.options_with_values && item.options_with_values.length && item.options_with_values[0].value !== 'Default Title'
        ? '<div class="cart-line__variant">' + item.options_with_values.map(function (o) { return o.value; }).join(' · ') + '</div>'
        : '';
      return '<div class="cart-line" data-line="' + (index + 1) + '">' +
        '<img src="' + img + '" alt="" width="70" height="70" loading="lazy">' +
        '<div><a class="cart-line__title" href="' + item.url + '">' + item.product_title + '</a>' + variant +
        '<div class="qty" data-qty>' +
          '<button type="button" data-qty-down aria-label="Weniger">&minus;</button>' +
          '<input type="text" value="' + item.quantity + '" data-line-qty inputmode="numeric" aria-label="Menge">' +
          '<button type="button" data-qty-up aria-label="Mehr">+</button>' +
        '</div>' +
        '<button class="cart-line__remove" data-line-remove>Entfernen</button></div>' +
        '<div class="price">' + formatMoney(item.final_line_price) + '</div>' +
        '</div>';
    }).join('');

    body.innerHTML = shipBarHtml(cart.requires_shipping ? cart.total_price : 0) + lines + upsellHtml(cart);
    foot.innerHTML =
      '<div class="cart-summary-row total"><span>Zwischensumme</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
      '<p style="font-size:1.3rem;color:var(--color-text-soft);margin:.4rem 0 1.6rem">Versand &amp; Steuern werden im Checkout berechnet.</p>' +
      '<a href="' + routes.cart_url + '" class="btn btn--full btn--lg">Zur Kasse</a>' +
      (needsCoding(cart) ? '<p style="font-size:1.2rem;color:var(--color-text-soft);text-align:center;margin:.8rem 0 0">Im nächsten Schritt: Unternehmensdaten für die Kartenprogrammierung.</p>' : '');

    bindLineEvents();
  }

  function refreshCart(openAfter) {
    return getCart().then(function (cart) {
      updateCartCount(cart.item_count);
      renderDrawer(cart);
      updateCartPage(cart);
      if (openAfter && window.theme.cartType === 'drawer') openPanel($('[data-cart-drawer]'));
      return cart;
    });
  }

  function changeLine(line, quantity) {
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      updateCartCount(cart.item_count);
      renderDrawer(cart);
      updateCartPage(cart);
      return cart;
    });
  }

  function bindLineEvents() {
    $$('[data-cart-body] [data-line]').forEach(function (row) {
      var line = parseInt(row.getAttribute('data-line'), 10);
      var input = $('[data-line-qty]', row);
      var up = $('[data-qty-up]', row);
      var down = $('[data-qty-down]', row);
      var remove = $('[data-line-remove]', row);
      if (up) up.addEventListener('click', function () { changeLine(line, parseInt(input.value, 10) + 1); });
      if (down) down.addEventListener('click', function () { changeLine(line, Math.max(0, parseInt(input.value, 10) - 1)); });
      if (input) input.addEventListener('change', function () { changeLine(line, Math.max(0, parseInt(input.value, 10) || 0)); });
      if (remove) remove.addEventListener('click', function () { changeLine(line, 0); });
    });
  }

  function addToCart(formData, button) {
    if (button) { button.classList.add('is-loading'); button.disabled = true; }
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    }).then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) { alert(res.data.description || res.data.message || 'Fehler'); return; }
        return refreshCart(true);
      })
      .catch(function () { window.location.href = routes.cart_url; })
      .finally(function () { if (button) { button.classList.remove('is-loading'); button.disabled = false; } });
  }

  function initCart() {
    // open drawer button
    $$('[data-cart-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (window.theme.cartType === 'drawer') {
          e.preventDefault();
          openPanel($('[data-cart-drawer]'));
          refreshCart(false);
        }
      });
    });
    $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeAll); });

    // Any add-to-cart form (product page + quick add)
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form]');
      if (!form) return;
      // Let the native dynamic-checkout (Shop Pay etc.) button submit straight to checkout.
      if (e.submitter && !e.submitter.hasAttribute('data-add-btn')) return;
      e.preventDefault();
      addToCart(new FormData(form), form.querySelector('[data-add-btn]') || $('[type="submit"]', form));
    });

    // Upsell-Button (Warenkorb-Seite und Mini-Warenkorb)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-upsell-add]');
      if (!btn) return;
      e.preventDefault();
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Wird hinzugefügt …';
      fetch(routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        if ($('[data-cart-page]')) { window.location.reload(); } else { refreshCart(false); }
      }).catch(function () {
        btn.disabled = false; btn.textContent = label;
      });
    });

    // Cart page qty controls (server-rendered)
    document.addEventListener('click', function (e) {
      var stepper = e.target.closest('[data-cart-page] [data-qty-up], [data-cart-page] [data-qty-down]');
      if (!stepper) return;
      var row = stepper.closest('[data-line]');
      var input = $('[data-line-qty]', row);
      var line = parseInt(row.getAttribute('data-line'), 10);
      var val = parseInt(input.value, 10) || 0;
      changeLine(line, e.target.closest('[data-qty-up]') ? val + 1 : Math.max(0, val - 1));
    });
  }

  function updateCartPage(cart) {
    var page = $('[data-cart-page]');
    if (!page) return;
    if (!cart.item_count) { window.location.reload(); return; }
    // Faellt eine Position ganz weg, kann sich auch der Programmier-Block aendern.
    if (parseInt(page.getAttribute('data-line-count'), 10) !== cart.items.length) { window.location.reload(); return; }
    var subtotal = $('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    cart.items.forEach(function (item, i) {
      var row = $('[data-line="' + (i + 1) + '"]', page);
      if (row) {
        var lp = $('[data-line-price]', row);
        var qi = $('[data-line-qty]', row);
        if (lp) lp.textContent = formatMoney(item.final_line_price);
        if (qi) qi.value = item.quantity;
      }
    });
  }

  /* ---------- Quantity steppers (non-cart, e.g. product form) ---------- */
  function initQtySteppers() {
    document.addEventListener('click', function (e) {
      var wrap = e.target.closest('[data-qty]:not([data-cart-body] *):not([data-cart-page] *)');
      if (!wrap) return;
      var input = $('input', wrap);
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      if (e.target.closest('[data-qty-up]')) input.value = val + 1;
      if (e.target.closest('[data-qty-down]')) input.value = Math.max(1, val - 1);
    });
  }

  /* ---------- Product page: variants + gallery ---------- */
  function initProduct() {
    var root = $('[data-product]');
    if (!root) return;

    // Gallery
    var mainImg = $('[data-product-main-img]', root);
    $$('[data-product-thumb]', root).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (mainImg && full) { mainImg.src = full; mainImg.srcset = ''; }
        $$('[data-product-thumb]', root).forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    // Variants
    var dataEl = $('[data-product-json]', root);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var form = $('[data-product-form]', root);
    var idInput = $('[name="id"]', form);
    var priceEl = $('[data-product-price]', root);
    var addBtn = $('[data-add-btn]', root);
    var mediaByVariant = root.getAttribute('data-media-map');

    function currentSelection() {
      return $$('[data-variant-option]', root).map(function (input) {
        if (input.type === 'radio') { return input.checked ? input.value : null; }
        return input.value;
      }).filter(function (v) { return v !== null; });
    }

    function findVariant(selected) {
      // Produkte mit nur einer Variante haben keine Auswahlfelder: dann direkt die einzige Variante nehmen.
      if (!selected.length && variants.length === 1) return variants[0];
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function update() {
      var selected = currentSelection();
      var variant = findVariant(selected);
      if (!variant) {
        addBtn.disabled = true;
        addBtn.textContent = strings.unavailable || 'Nicht verfügbar';
        return;
      }
      idInput.value = variant.id;
      if (priceEl) {
        var html = '<span class="price' + (variant.compare_at_price > variant.price ? ' price--sale' : '') + '">';
        if (variant.compare_at_price > variant.price) {
          html += '<span class="price__sale">' + formatMoney(variant.price) + '</span>' +
            '<span class="price__compare">' + formatMoney(variant.compare_at_price) + '</span>';
        } else {
          html += formatMoney(variant.price);
        }
        html += '</span>';
        priceEl.innerHTML = html;
      }
      var savingsEl = root.querySelector('[data-product-savings]');
      if (savingsEl) {
        if (variant.compare_at_price > variant.price) {
          var diff = variant.compare_at_price - variant.price;
          var pct = Math.round(diff * 100 / variant.compare_at_price);
          savingsEl.textContent = 'Du sparst ' + formatMoney(diff) + ' (' + pct + ' %)';
          savingsEl.hidden = false;
        } else {
          savingsEl.hidden = true;
        }
      }
      var noteEl = root.querySelector('[data-compare-note]');
      if (noteEl) noteEl.hidden = !(variant.compare_at_price > variant.price);
      if (variant.available) {
        addBtn.disabled = false;
        addBtn.textContent = strings.addToCart || 'In den Warenkorb';
      } else {
        addBtn.disabled = true;
        addBtn.textContent = strings.soldOut || 'Ausverkauft';
      }
      // swap image if variant has featured media
      if (variant.featured_media && mainImg) {
        var img = variant.featured_media.preview_image;
        if (img) { mainImg.src = img.src; mainImg.srcset = ''; }
      }
      // reflect in URL for shareability
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    $$('[data-variant-option]', root).forEach(function (input) {
      input.addEventListener('change', update);
    });
    update();
  }

  /* ---------- Lieferdatum (Berliner Zeit, Werktage Mo–Fr ohne eingetragene Feiertage) ---------- */
  function deliveryPlan(now, o) {
    var holidays = o.holidays || [];
    function iso(d) { return d.toISOString().slice(0, 10); }
    function isWorkday(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && holidays.indexOf(iso(d)) === -1; }
    function nextWorkday(d) { var n = new Date(d.getTime()); do { n.setUTCDate(n.getUTCDate() + 1); } while (!isWorkday(n)); return n; }
    function addWorkdays(d, k) { var n = d; for (var i = 0; i < k; i++) n = nextWorkday(n); return n; }
    var today = new Date(Date.UTC(now.year, now.month - 1, now.day));
    var nowMin = now.hour * 60 + now.minute;
    var sameDay = isWorkday(today) && nowMin < o.cutoff * 60;
    var fastShip = sameDay ? today : nextWorkday(today);
    var stdShipFrom = o.pmin > 0 ? addWorkdays(today, o.pmin) : fastShip;
    var stdShipTo = o.pmax > 0 ? addWorkdays(today, Math.max(o.pmin, o.pmax)) : fastShip;
    return {
      sameDay: sameDay,
      minutesLeft: sameDay ? o.cutoff * 60 - nowMin : 0,
      fastShip: fastShip,
      fastShipTomorrow: !sameDay && (fastShip.getTime() - today.getTime() === 864e5),
      stdFrom: addWorkdays(stdShipFrom, o.tmin),
      stdTo: addWorkdays(stdShipTo, Math.max(o.tmin, o.tmax)),
      fastFrom: addWorkdays(fastShip, o.fmin),
      fastTo: addWorkdays(fastShip, Math.max(o.fmin, o.fmax))
    };
  }

  function parseHolidays(str) {
    return (str || '').split(/[\s,;]+/).map(function (s) {
      var p = s.split('.');
      return p.length >= 3 && p[2] ? p[2] + '-' + ('0' + p[1]).slice(-2) + '-' + ('0' + p[0]).slice(-2) : '';
    }).filter(Boolean);
  }

  function initDelivery() {
    var el = $('[data-delivery]');
    if (!el || !window.Intl || !Intl.DateTimeFormat.prototype.formatToParts) return;
    function num(a, d) { var v = parseInt(el.getAttribute(a), 10); return isNaN(v) ? d : v; }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    var o = { cutoff: num('data-cutoff', 12), pmin: num('data-pmin', 1), pmax: num('data-pmax', 2), tmin: num('data-tmin', 1), tmax: num('data-tmax', 3), fmin: num('data-fmin', 1), fmax: num('data-fmax', 2), holidays: parseHolidays(el.getAttribute('data-holidays')) };
    var fastLabel = esc(el.getAttribute('data-fast-label') || 'Schnellversand');
    var fastPrice = el.getAttribute('data-fast-price');
    var berlin = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
    var fmt = new Intl.DateTimeFormat('de-DE', { timeZone: 'UTC', weekday: 'short', day: '2-digit', month: '2-digit' });
    function f(d) { return fmt.format(d).replace('., ', ', '); }
    function span(a, b) { return a.getTime() === b.getTime() ? f(a) : f(a) + ' – ' + f(b); }
    var ptxt = o.pmin === o.pmax ? String(o.pmin) : o.pmin + '–' + o.pmax;
    var main = el.querySelector('[data-delivery-main]');
    var fast = el.querySelector('[data-delivery-fast]');
    function render() {
      var parts = {};
      berlin.formatToParts(new Date()).forEach(function (p) { parts[p.type] = parseInt(p.value, 10); });
      var p = deliveryPlan(parts, o);
      if (main) main.innerHTML = 'Standardversand (Versand in ' + ptxt + ' Werktagen): Ankunft voraussichtlich <strong>' + span(p.stdFrom, p.stdTo) + '</strong>.';
      if (fast && fastPrice) {
        var lead;
        if (p.sameDay) {
          var h = Math.floor(p.minutesLeft / 60), m = p.minutesLeft % 60;
          lead = 'Bestellst du in den nächsten <span class="delivery__count">' + (h ? h + ' Std. ' : '') + m + ' Min.</span>, verschicken wir <strong>heute</strong>.';
        } else {
          lead = 'Versand ' + (p.fastShipTomorrow ? '<strong>morgen</strong>' : 'am <strong>' + f(p.fastShip) + '</strong>') + '.';
        }
        fast.innerHTML = '<strong>' + fastLabel + ' (' + esc(fastPrice) + '):</strong> ' + lead + ' Ankunft <strong>' + span(p.fastFrom, p.fastTo) + '</strong>.';
      }
    }
    render();
    setInterval(render, 60000);
  }

  function initCookiePrefs() {
  var btn = document.querySelector('[data-cookie-prefs]');
  if (!btn) return;
  function api() {
    return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function' ? window.privacyBanner : null;
  }
  function reveal() { if (api()) btn.hidden = false; }
  reveal();
  window.setTimeout(reveal, 1500);
  document.addEventListener('visitorConsentCollected', reveal);
  btn.addEventListener('click', function () {
    var a = api();
    if (a) a.showPreferences();
  });
}

/* ---------- Newsletter / contact inline feedback handled by Shopify markup ---------- */

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    ensureOverlay();
    initReveal();
    initMobileNav();
    initCart();
    initQtySteppers();
    initProduct();
  initCookiePrefs();
    initDelivery();
    // keep count in sync on load
    getCart().then(function (cart) { updateCartCount(cart.item_count); }).catch(function () {});
  });
})();
